import React, { useEffect, useState } from "react";
import { modulegroupProps } from "./modulegroup-interface";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Progress, Timeline } from "antd";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../../../../store/store";
import { useSelector } from "react-redux";

const percentage = 30;

const Modulegroup = ({ details, index, openLevel }: modulegroupProps) => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [dataItems, setDataItems] = useState<any[]>([]);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  useEffect(() => {
    setCollapsed(details.open);
  }, [details.open]);

  const runNavigate = (typeModel: string, _id: string) => {
    if (typeModel === "RamRun") {
      navigate(`/${user?.userType}/dashboard/ramruns/${_id}`);
    }
    if (typeModel === "Lesson") {
      navigate(`/ide/${_id}`);
    }
  };

  useEffect(() => {
    const newDataItems: any[] = [];
    let unitCount = 0;
    let assignmentNumber = 0;

    details.units.forEach((item: any) => {
      if (item.typeModel !== "Assignment") {
        unitCount += 1;
      } else {
        assignmentNumber += 1;
      }

      let obj = {
        dot: (
          <div
            className="cursor-pointer"
            onClick={() => {
              runNavigate(item?.typeModel, item?.typeId?._id);
            }}
          >
            <img
              src={`/img/vectors/${
                item?.isCompleted
                  ? "moduledone.svg"
                  : item.typeModel === "Assignment"
                  ? "moduleassignment.svg"
                  : "moduleunit.svg"
              }`}
              alt={item.typeModel}
            />
          </div>
        ),
        children: (
          <div
            className="flex cursor-pointer items-center text-lg font-semibold leading-[26px]"
            onClick={() => {
              runNavigate(item?.typeModel, item?.typeId?._id);
            }}
          >
            <p className="mr-[0.5rem] text-appcolorblack">
              {item.typeModel === "Assignment" ? (
                <>Assignment {assignmentNumber}</>
              ) : (
                <>Unit {unitCount}:</>
              )}
            </p>
            {item.typeModel !== "Assignment" ? (
              <p className="text-appcolorgreyfaintfour">
                {item?.typeId?.title}
              </p>
            ) : null}
          </div>
        ),
      };
      newDataItems.push(obj);
    });

    setDataItems(newDataItems);

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div
        className="custom-grey-bg-faint relative mb-4 flex w-full cursor-pointer items-center justify-between rounded-t-[20px] px-[1.25rem] py-[0.75rem]"
        onClick={() => {
          openLevel(index, !collapsed);
        }}
      >
        <div className="flex items-center text-lg font-semibold leading-[26px] ">
          <p className="mr-[0.5rem] text-appcolorblack">Level {index + 1}:</p>
          <p className="text-appcolorgreyfaintfour">{details.name}</p>
        </div>

        <div className="flex items-center">
          {collapsed ? <DownOutlined /> : <UpOutlined />}
        </div>

        <div className="absolute left-0 w-full -bottom-4">
          <Progress percent={percentage} showInfo={false} />
        </div>
      </div>

      <div className="px-2 pt-4">
        {collapsed ? (
          <div>
            <Timeline pending={false} items={dataItems} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Modulegroup;
